/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018, 2022
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../lib/@waca/dashboard-common/dist/utils/TextEditorConstants',
	'./FontUtils'
], function(TextEditorConstants, FontUtils) {
	let instance = null;

	const LW_FONT_FAMILY = [{
		'value': 'IBM Plex Sans,Helvetica Neue,Arial,sans-serif',
		'label': 'IBM Plex Sans',
		'cssClass': ''
	}, {
		'value': 'IBM Plex Sans Condensed,Helvetica Neue,Arial,sans-serif',
		'label': 'IBM Plex Sans Condensed',
		'cssClass': ''
	}];
	if (!instance) {
		instance = FontUtils.normalizeFonts(TextEditorConstants.FONT_FAMILY_CHOICES.concat(LW_FONT_FAMILY));
		instance = FontUtils.sortByLabel(instance);
	}

	return instance;

});
